var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import PageHeader from '@/components/page-header/PageHeader';
let RosterNotfications = class RosterNotfications extends Vue {
    constructor() {
        super(...arguments);
        this.parsedNotifications = {};
    }
    mounted() { }
    parseNotifications() {
        const parsed = {};
        this.parsedNotifications = {};
        this.notifications.forEach((notification) => {
            const date = DateTime.fromSQL(notification.starts_at).toFormat('yyyy-LL-dd');
            if (!parsed[date]) {
                parsed[date] = [notification];
            }
            else {
                parsed[date].push(notification);
            }
        });
        this.parsedNotifications = parsed;
    }
    get breadcrumbs() {
        return [{ name: 'Roster Notifications', path: '/roster/management/notifications' }];
    }
    back() {
        this.$router.go(-1);
    }
    notificationsChanged(notifications) {
        this.parseNotifications();
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], RosterNotfications.prototype, "notifications", void 0);
__decorate([
    Watch('notifications'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], RosterNotfications.prototype, "notificationsChanged", null);
RosterNotfications = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], RosterNotfications);
export default RosterNotfications;
